import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    logoutAction,
    Logout
} from '../store/actions/AuthActions';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    // const postData = {
    //     email,
    //     password,
    //     returnSecureToken: true,
    // };
    // return axios.post(
    //     `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    //     postData,
    // );
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        let locationState = { code: 200, status: 'success', message: 'You have been logged out due to inactivity.' }
        dispatch(Logout(navigate, locationState));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate, location) {
    const publicRoutes = ["/signup", "/forgot-password", "/verify-otp", "/reset-password", "/social-login", "/verify-user", "/verify-phone", "/change-email", "/change-phone", "/ticket/view"];
    const currentPath = window.location.pathname;
    
    if (publicRoutes.includes(currentPath)) {
        console.log("Public route, skipping auth check.");
        return;
    }

    if(
        currentPath.match(/^\/dashboard\/events-details\/book-ticket\/\d+$/) || 
        currentPath.match(/^\/resell-market\/ticket-list\/\d+$/) || 
        currentPath.startsWith("/ticket/view")
    ) {
        console.log("Public route, skipping auth check.");
        return;
    }
    
    const urlParams = new URLSearchParams(location.search);
    const redirectTo = urlParams.get("redirect");
    const eventId = urlParams.get("e_id");
    const dayPass = urlParams.get("day_pass");

    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        let locationState = { code: 200, status: 'success', message: '', redirect: redirectTo, e_id: eventId, day_pass: dayPass }
        dispatch(Logout(navigate, locationState));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        let locationState = { code: 200, status: 'success', message: 'You have been logged out due to token expiry.', redirect: redirectTo, e_id: eventId, day_pass: dayPass }
        dispatch(Logout(navigate, locationState));
        return;
    }

    let redirectPath = "/dashboard";
    if (redirectTo && eventId) {
        if (redirectTo === "book-ticket") {
            redirectPath = `/dashboard/events-details/book-ticket/${eventId}`;
            if (dayPass) {
            redirectPath += `?day_pass=${dayPass}`;
            }
        } else if (redirectTo === "resell-market") {
            redirectPath = `/resell-market/ticket-list/${eventId}`;
        }
    }
    dispatch(loginConfirmedAction(tokenDetails));
    navigate(redirectPath);

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
